import { render, staticRenderFns } from "./MessengerChannels.vue?vue&type=template&id=37b0febe&scoped=true"
import script from "./MessengerChannels.vue?vue&type=script&lang=js"
export * from "./MessengerChannels.vue?vue&type=script&lang=js"
import style0 from "./MessengerChannels.vue?vue&type=style&index=0&id=37b0febe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b0febe",
  null
  
)

export default component.exports